import { RequestsView } from "@/features/requests/components/RequestView"

export default function RequestsPage() {
  return <RequestsView />
}